module.exports = __webpack_public_path__ + "img/green-wave-top.263c39af.png";